import React from 'react';
import AboutImage from '../assets/images/about.png';

function About() {
    return (
        <section className="about" id="about">
            <div className="about-img">
                <img src={AboutImage} alt="Rastra D. Karki" />
            </div>
            <div className="about-content">
                <h2 className="heading">About <span>Me</span></h2>
                <h3>MSc in Artificial Intelligence | Full Stack Developer | 5+ Years Experience</h3>
                <p>
                    I am a passionate software engineer with hands on experience designing and deploying 
                    AI recommendation systems, full stack web applications, and scalable backend solutions. 
                    I have built advanced computer vision and natural language models using TensorFlow and PyTorch.
                </p>
                <p>
                    I hold a Distinction in MSc in Artificial Intelligence from Queen Mary University of London, 
                    where my thesis focused on AI oral health assessment. I also completed my BSc Hons in Computing 
                    from Coventry University, with a final project delivering a job recommendation system that 
                    improved candidate to role matching.
                </p>
                <p>
                    With 5+ years of work experience as a software developer, I am seeking roles as a 
                    Software Engineer, Data Scientist, Machine Learning Engineer, or AI Research Specialist. 
                    I am always eager to learn new skills and take on challenges that deliver high quality work.
                </p>
                <div className="about-links" style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                    <a href="#contact" className="btn">Let's Connect</a>
                    <a 
                        href="https://www.linkedin.com/in/rastrakarki/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn btn-outline"
                    >
                        View LinkedIn
                    </a>
                </div>
            </div>
        </section>
    );
}

export default About;